var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".processing-card[data-v-24c6158d] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.98);\n  z-index: 10;\n  padding: 1rem;\n}\n\n.processing-card .card[data-v-24c6158d] {\n  width: 100%;\n  max-width: 600px;\n  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Complete = require("../Complete.vue");

var _Complete2 = _interopRequireDefault(_Complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "UnifiedCheckoutProcessing",
  components: {
    Complete: _Complete2.default
  },
  props: {
    state: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ["processing", "success", "manual"].includes(value);
      }
    },
    status_api_url: String,
    invoice_no: String,
    gateway_id: [String, Number],
    callback_url: String
  },
  watch: {
    state: function state(newState) {
      var _this = this;

      if (newState === "success") {
        setTimeout(function () {
          _this.redirectToCallback();
        }, 1000);
      }
    }
  },
  methods: {
    redirectToCallback: function redirectToCallback() {
      if (this.callback_url) {
        window.location.href = this.callback_url;
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processing-card"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"mb-0"},[(_vm.state === 'processing')?_c('span',[_vm._v("Processing your payment, please wait...")]):_vm._e(),_vm._v(" "),(_vm.state === 'success')?_c('span',{staticClass:"text-success"},[_vm._v("Payment Successful")]):_vm._e(),_vm._v(" "),(_vm.state === 'manual')?_c('span',[_vm._v("We are confirming your payment")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-body text-center py-5"},[(_vm.state === 'processing')?_c('div',[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"lead mb-0"},[_vm._v("\n          Do not close this window until your payment processing is complete.\n        ")])]):_vm._e(),_vm._v(" "),(_vm.state === 'success')?_c('div',[_vm._m(1),_vm._v(" "),_c('p',{staticClass:"lead mb-0"},[_vm._v("Redirecting you...")])]):_vm._e(),_vm._v(" "),(_vm.state === 'manual')?_c('div',[_vm._m(2),_vm._v(" "),_c('p',{staticClass:"lead mb-0"},[_vm._v("If nothing happens, click Complete below.")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('Complete',{attrs:{"status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_no,"gateway_id":_vm.gateway_id,"callback_url":_vm.callback_url}}),_vm._v(" "),_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){return _vm.window.location.reload()}}},[_vm._v("\n        Cancel\n      ")])],1)])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary mb-3",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-success mb-3"},[_c('i',{staticClass:"fe fe-check-circle",staticStyle:{"font-size":"4rem"}})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-warning mb-3"},[_c('i',{staticClass:"fe fe-clock",staticStyle:{"font-size":"4rem"}})])}]
__vue__options__._scopeId = "data-v-24c6158d"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24c6158d", __vue__options__)
  } else {
    hotAPI.reload("data-v-24c6158d", __vue__options__)
  }
})()}